import * as React from 'react';
import { connect } from 'react-redux';
import { Toast } from 'reducers/toasts';
import ToastComponent, { defaultToastOptions, ToastOptions } from 'components/Toast';
// @ts-ignore
import { isVIP } from 'lib/telemetry';
// @ts-ignore
import { CSSTransitionGroup } from 'react-transition-group';
import { bindActionCreators, Dispatch } from 'redux';
import { remove, State as ToastsState } from 'reducers/toasts';
import { List } from 'immutable';

import './styles/ToastsContainer.scss';

const MINIMUM_TIMEOUT = 1000;
const TIME_PER_CHARACTER = 100;

function calculateTimeout(toast: Toast): number {
  return MINIMUM_TIMEOUT + toast.text.length * TIME_PER_CHARACTER;
}

type Props = {
  toasts: List<Toast>;
  remove: (toast: Toast) => any;
};

class ToastsContainer extends React.Component<Props> {
  componentWillReceiveProps(nextProps: Props) {
    const newToast = nextProps.toasts.last();
    const toasts = nextProps.toasts.slice(0, -1);

    // Because we are going to clear all but the new toast
    // we can clear this timeout, no problemo.
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    // Clear all the toasts but the new one.
    toasts.forEach(toast => this.props.remove(toast as Toast));

    // clear the new toast after a little time.
    if (newToast) {
      this.timeout = setTimeout(() => this.props.remove(newToast), calculateTimeout(newToast));

      if (newToast.kind === 'error' && isVIP()) {
        console.error(`Red Toast - ${newToast.text}`);
      }
    }
  }

  timeout: any;

  renderToast(toast: Toast) {
    let options: ToastOptions | undefined;

    if (toast.kind === 'success') {
      options = defaultToastOptions.success;
    } else if (toast.kind === 'error') {
      options = defaultToastOptions.error;
    } else if (toast.options) {
      options = toast.options;
    }

    if (options) {
      return (
        <ToastComponent key={toast.uuid} color={options.color} glyph={options.glyph}>
          {toast.text}
        </ToastComponent>
      );
    } else {
      console.error(`got unknown options for toast ${toast.kind}`);
      return null;
    }
  }

  render() {
    return (
      <div className="ToastsContainer">
        <CSSTransitionGroup
          transitionAppear
          transitionName="toasts"
          transitionEnterTimeout={500}
          transitionAppearTimeout={500}
          transitionLeaveTimeout={500}>
          {this.props.toasts.toArray().map(toast => this.renderToast(toast))}
        </CSSTransitionGroup>
      </div>
    );
  }
}

function mapStateToProps(state: { toasts: ToastsState }) {
  return {
    toasts: state.toasts,
  };
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
  return bindActionCreators({ remove }, dispatch);
}

export { ToastsContainer };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ToastsContainer);
